/** @jsxImportSource @emotion/react */
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Divider, Fade, Grid } from '@mui/material';
import { MenuType } from 'api/models';
import ItemGroup from 'components/ItemGroup/ItemGroup';
import CheckoutItemCard from 'pages/Checkout/components/CheckoutItemCard';
import { formatDayLabel } from 'utils/formatDayLabel';
import { getMenuTypeText } from 'utils/getMenuTypeText';
import { groupBy } from 'utils/groupBy';
import { Props } from './types';

const CheckoutList: FC<Props> = ({ items, dayDate }) => {
  const { t } = useTranslation();

  const menuTypes = Object.values(MenuType);

  const groups = Object.entries(
    groupBy(
      items,
      (item) => menuTypes.find((type) => type === item.menuType) || '',
    ),
  );

  return (
    <Fade in>
      <Grid container direction="column" spacing={6}>
        {groups.map(([menuType, groupItems], index) => (
          <React.Fragment key={menuType}>
            <ItemGroup
              title={t(getMenuTypeText(menuType as MenuType))}
              caption={dayDate && formatDayLabel(dayDate)}
            >
              {groupItems.map((item) => (
                <Grid item key={item.item.id}>
                  <CheckoutItemCard item={item.item} quantity={item.quantity} />
                </Grid>
              ))}
            </ItemGroup>

            {index !== groups.length - 1 && (
              <Grid item>
                <Divider />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    </Fade>
  );
};

export default memo(CheckoutList);
